import { render, staticRenderFns } from "./correct.vue?vue&type=template&id=c69ae7d6&scoped=true"
import script from "./correct.vue?vue&type=script&lang=js"
export * from "./correct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69ae7d6",
  null
  
)

export default component.exports